// Common formatting utilities for ROB Survey forms.

/**
 * Strips trailing zeros from a fixed-decimal string, keeping at least one decimal place.
 * e.g. "123.000" → "123.0",  "123.450" → "123.45",  "123.456" → "123.456"
 */
export const stripTrailingZeros = fixed => {
  const n = Number(fixed)

  return n % 1 === 0 ? n.toFixed(1) : String(n)
}

/**
 * Formats a numeric value to 3 decimal places with trailing zeros stripped.
 * Returns '—' for null/undefined.
 */
export const fmt = v =>
  v === null || v === undefined ? '—' : stripTrailingZeros(Number(v).toFixed(3))

/**
 * Formats a percentage value to 3 decimal places with trailing zeros stripped.
 * Returns '—' for null/undefined.
 */
export const fmtPct = v =>
  v === null || v === undefined ? '—' : stripTrailingZeros(Number(v).toFixed(3))
